import { TypographyV3 } from '@jouzen/ecom-components';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';

import EmailForm from '@/app/components/OutOfStockModal/EmailForm';

interface OutOfStockModalProps {
  readonly oosRingSku: string;
  readonly onSubmit: () => void;
}

// TODO (GROW-2462) - Hook up this modal to the 'OOS - Notify Me' button. Also pass in the correct oosRingSku prop.
export default function OutOfStockModalContent({
  oosRingSku,
  onSubmit,
}: OutOfStockModalProps) {
  const t = useTranslations();
  const path = usePathname();

  return (
    <div data-cy="out-of-stock-modal-content">
      <TypographyV3
        className="mb-1 text-xl font-bold tracking-normal md:mt-4"
        Element="h2"
        variant="h2"
      >
        {t('ring_pdp_2025_oos_modal_title')}
      </TypographyV3>
      <TypographyV3
        variant="h2"
        className="mb-6 text-xl font-normal tracking-normal text-gray-400"
      >
        {t('ring_pdp_2025_oos_modal_subtitle')}
      </TypographyV3>
      <TypographyV3 className="text-sm font-normal">
        {t('ring_pdp_2025_oos_modal_copy')}
      </TypographyV3>
      <EmailForm
        onSubmit={onSubmit}
        eventProperties={{
          oosRingSku: oosRingSku,
          oosRingUrl: path,
          productType: 'Ring',
        }}
      />
    </div>
  );
}
